// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6106) return "static/chunks/6106-5218bbefc0cf648e.js";
	if (chunkId === 8500) return "static/chunks/8500-21cc63092ed49fc8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1656":"0206c5316719f36d","3126":"3845276b29ccc550","4987":"489fa3435f340a12","6483":"3b76a5b9208745f4","7612":"56c0892b840858a1","9454":"bd8bc9c1c89432fe"}[chunkId] + ".js";
};